

function activeBases(auth) {
    const bases = auth.bases.filter(base => base.active).map(base => { return base.name })
    return bases
}

export function removeNoPermission(auth) {

    const bases = activeBases(auth)
    let modules = {}
    const modulos = auth.grupos[auth.grupo_ativo].bases
    bases.forEach(base => {
        if (modulos[base].modulos) {
            Object.keys(modulos[base].modulos).forEach(modulo => {
                if (modulos[base].modulos[modulo].ativo) modules[modulo] = modulo
            });
        }
    });
    return modules


}

const tmsGroupPermited = [
    'AZAPERS',
    'AZAPFY',
    'ASA',
    'ASSUNCAO',
    'JR',
    'VDC',
    'VDCLOG',
    'TRANSPAPER',
    'ALMEIDA',
    'LF',
    'JOBSON',
    'JD',
    'MARINHO',
    'JSP',
    'R2B'
]

const frotasGroupPermited = [
    "AZAPERS",
    "AZAPFY",
    "R2B"
]

function havePermission(auth) {
    const hasPermission = [
        "SUPER",
        "ADMIN",
        "GESTOR",
        "COLABORADOR"]
    return hasPermission.includes(auth.grupos[auth.grupo_ativo]?.user?.grupo);
}

function removeParentByPermissions(auth, modules, SUPER, ADMIN, module) {
    const permissions = removeNoPermission(auth)
    if (modules) {
        for (var i = 0; i < modules.length; i++) {
            if (permissions[modules[i].id]) return true
            else if (modules[i].id === 'roteirizacao') {
                if (['TRANSLIMA', 'TETS', 'AZAPERS'].includes(auth.grupo_ativo)) {
                    return true
                }
            }
            else if (auth.v4_modules && auth.v4_modules.ids?.includes(modules[i].id)) return true
            else if (modules[i].id == 'tms' && tmsGroupPermited.includes(auth.grupo_ativo) && havePermission(auth)) return true
            else if (modules[i].id == 'frotas' && frotasGroupPermited.includes(auth.grupo_ativo) && havePermission(auth)) return true
            else if (modules[i].id == 'frotas' && modules[i].route == "/frotas" && havePermission(auth)) return true
            else if (modules[i].id == 'cotacao' && havePermission(auth)) return true
            else if (modules[i].permission == false) return true
            else if (modules[i].admin && (ADMIN || SUPER)) return true
            else if (modules[i].super && (SUPER)) return true
        }
        return false
    }
    else if (module) {
        if (permissions[module.id]) return true
        else if (auth.v4_modules && auth.v4_modules.ids?.includes(module.id)) return true
        else if (module.id == 'tms' && tmsGroupPermited.includes(auth.grupo_ativo) && havePermission(auth)) return true
        else if (module.id == 'frotas' && frotasGroupPermited.includes(auth.grupo_ativo) && havePermission(auth)) return true
        else if (module.id == 'frotas' && module.route == "/frotas" && havePermission(auth)) return true
        else if (module.id == 'cotacao' && havePermission(auth)) return true
        else if ((module.id == "operacional" || module.id == "analitico") && permissions['dashboard']) return true
        else if (module.permission == false) return true
        else if (module.admin && (ADMIN || SUPER)) return true
        else if (module.super && (SUPER)) return true
        else return false
    }
    else return true
}

export default removeParentByPermissions
